import { createFileRoute } from "@tanstack/react-router"
import { SupportPanel } from "@/features/support"

export const Route = createFileRoute("/candidate/settings/support")({
  component: SupportPanel,
})
